import { configureStore } from '@reduxjs/toolkit'
import logger from 'redux-logger'
import appSlice from '../features/appSlice'
import assistantSlice from '../features/assistantSlice'
import pipelineSlice from '../features/pipelineSlice'
import templateSlice from '../features/templateSlice'

/**
 * The store's middleware for a build mode. redux-logger prints every action
 * and the whole state, user email included, to the console, so it is added
 * for `npm start` (development) only: never production builds or tests.
 *
 * @param {string} nodeEnv  process.env.NODE_ENV
 */
export const middlewareFor = (nodeEnv) => (getDefaultMiddleware) =>
    nodeEnv === 'development'
        ? getDefaultMiddleware().concat(logger)
        : getDefaultMiddleware()

export default configureStore({
    reducer: {
        pipeline: pipelineSlice,
        app: appSlice,
        template: templateSlice,
        assistant: assistantSlice,
    },
    middleware: middlewareFor(process.env.NODE_ENV),
})
